<span [class]="class">{{current.value}}{{unit || ''}}</span>